import { StepperType, stepperTypeSelector, useAppSelector } from "@repo/logic";
import DOMPurify from "dompurify";
import { FC, useMemo } from "react";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import { DefaultStepProps } from "../Stepper/CustomStepper";
import * as Styled from "./PensionQuestionnaireStartPage.styled";

export const PensionQuestionnaireStartPage: FC<DefaultStepProps> = () => {
    const { t } = useTypedTranslation();
    const stepperType = useAppSelector(stepperTypeSelector);

    const sanitizedContent = useMemo(
        () => ({
            description02: DOMPurify.sanitize(t("investmentStrategy.pensionQuestionnaire.description02html"), {
                ALLOWED_TAGS: ["strong"],
            }),
            description05: DOMPurify.sanitize(t("investmentStrategy.pensionQuestionnaire.description05html"), {
                ALLOWED_TAGS: ["u"],
            }),
            introTextPensionQuestionnaire: DOMPurify.sanitize(
                t("investmentStrategy.pensionQuestionnaire.questionnaireIntroTextPensionQuestionnaireHtml"),
                {
                    ALLOWED_TAGS: ["strong"],
                },
            ),
        }),
        [t],
    );

    switch (stepperType) {
        case StepperType.ChangePensionContribution:
            return (
                <Styled.Wrapper>
                    <Styled.Title>{t("investmentStrategy.pensionQuestionnaire.title")}</Styled.Title>
                    <Styled.Paragraph>
                        {t("employerContributeDialog.questionnaireIntroTextChangeContribution")}
                    </Styled.Paragraph>
                    <Styled.AlertWrapper>
                        {t("investmentStrategy.pensionQuestionnaire.description04bold")}
                        {t("investmentStrategy.pensionQuestionnaire.description04")}
                    </Styled.AlertWrapper>
                    <Styled.Paragraph
                        dangerouslySetInnerHTML={{ __html: sanitizedContent.description02 }}
                    ></Styled.Paragraph>
                    <Styled.Paragraph
                        dangerouslySetInnerHTML={{ __html: sanitizedContent.description05 }}
                    ></Styled.Paragraph>
                </Styled.Wrapper>
            );
        case StepperType.ChangeInvestmentStrategy:
            return (
                <Styled.Wrapper>
                    <Styled.Title>{t("investmentStrategy.pensionQuestionnaire.title")}</Styled.Title>
                    <Styled.Paragraph>
                        {t("investmentStrategy.pensionQuestionnaire.questionnaireIntroTextChangeInvestmentStrategy")}
                    </Styled.Paragraph>
                    <Styled.Paragraph>
                        {t(
                            "investmentStrategy.pensionQuestionnaire.questionnaireImportanceTextChangeInvestmentStrategy",
                        )}
                        <Styled.Bold>
                            {t(
                                "investmentStrategy.pensionQuestionnaire.questionnaireImportanceTextChangeInvestmentStrategyBold",
                            )}
                        </Styled.Bold>
                    </Styled.Paragraph>
                    <Styled.Paragraph>{t("investmentStrategy.pensionQuestionnaire.description03")}</Styled.Paragraph>
                    <Styled.Paragraph>
                        <Styled.Bold>{t("investmentStrategy.pensionQuestionnaire.description04bold")}</Styled.Bold>
                        {t("investmentStrategy.pensionQuestionnaire.description04")}
                    </Styled.Paragraph>
                </Styled.Wrapper>
            );
        case StepperType.PensionQuestionnaire:
            return (
                <Styled.Wrapper>
                    <Styled.Title>{t("investmentStrategy.pensionQuestionnaire.title")}</Styled.Title>
                    <Styled.Paragraph
                        dangerouslySetInnerHTML={{ __html: sanitizedContent.introTextPensionQuestionnaire }}
                    ></Styled.Paragraph>
                    <Styled.Paragraph
                        dangerouslySetInnerHTML={{ __html: sanitizedContent.description05 }}
                    ></Styled.Paragraph>
                    <Styled.Paragraph>{t("investmentStrategy.pensionQuestionnaire.description06")}</Styled.Paragraph>
                </Styled.Wrapper>
            );
        default:
            console.error("Unknown stepper type in PensionQuestionnaireStartPage:", stepperType);
    }
};
